import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import {
  getUserRequests,
  getContracts,
  hideModal
} from '../../state/actions/stepActions'
import { pushRoute } from '../../utils'
import Page from '../../components/page'
import Header from '../../components/header'
import Wrapper from '../../components/wrapper'
import Clearfix from '../../components/clearfix'
import Title from '../../components/title'
import Footer from '../../components/footer'
import Spinner from '../../components/spinner'
import Modal from '../../components/modal'
import Requests from '../../components/requests'
import Result from '../../components/result'
import {ios11Instructions} from '../../utils'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'
import BlockedAccess from '../../components/blockedAccess'
import { ProgressBar } from '../../components/progressBar'

class List extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { dispatch, routing } = this.props
    dispatch(getUserRequests()).then(json => {
      if (json.status !== 'success') {
        dispatch(hideModal())
        pushRoute(`/resume/${routing.flow}`)
      } else {
        dispatch(getContracts(json.data.map(req => req.guid)))
      }
    })
  }

  render() {
    // Check if blocking is enabled in configuration
    const isBlockingEnabled = window.APP_CONFIG && window.APP_CONFIG.ENABLE_BLOCKING === true
    
    if (isBlockingEnabled) {
      return (
        <Page>
          <Header>
            <ProgressBar StepNumber={0} NoOfSteps={0}/>
          </Header>
          <BlockedAccess />
          <Footer StepNumber="0"/>
        </Page>
      )
    }
    
    // Otherwise show normal application
    return this.renderOriginal()
  }
  
  // Original render method preserved below (not executed)
  renderOriginal() {
    let IOS11Rules=ios11Instructions()
    if (!this.globalStylesOverrides) {
      this.globalStylesOverrides = css(this.props.styles.globals)
    }

    if (this.props.step.isLoading) {
      return <Spinner type="global" />
    }

    if (this.props.step.hasServerErrors) {
      return (
        <Modal>
          <Result type="error">
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.step.serverErrorMessage
              }}
            />
            <div dangerouslySetInnerHTML={{ __html:IOS11Rules}} />
          </Result>
        </Modal>
      )
    }

    return (
      <Page>
        {this.props.step.isStepLoading ? <Spinner type="step" /> : ''}
        <Header
          centeredLogo={true}
          whiteLabel={
            !!this.props.routing.locationBeforeTransitions.query.embedded
          }
        />
        <Wrapper>
          <Title
            title={'Richieste in corso'}
            subtitle={'Qui di seguito sono elencate le tue richieste in corso:'}
          />

          <Requests
            requestList={this.props.step.requestList}
            contractList={this.props.step.contractList}
          />

          <Clearfix />
        </Wrapper>
        <Footer />
      </Page>
    )
  }
}

List.propTypes = {
  guid: PropTypes.string,
  step: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    ...state
  }
}

export default connect(mapStateToProps)(withStyles(Styles)(List))



// WEBPACK FOOTER //
// ./containers/list/index.js